export const trailerMessages = {
  'zh-CN': {
    cache: '缓存到 R2',
    finding: '正在查找预告片来源…',
    refreshSources: '重新查找来源',
    sourceError: '预告片来源查询失败，请重试。',
    playFailed: '所有预告片来源播放失败，请刷新来源后重试。',
    refresh: '刷新预告片',
    fetching: '正在缓存到 R2…',
    confirm: '确认预告片状态',
    progress: '正在缓存预告片到 R2，可能需要几分钟；可以继续播放原来源。',
    paidOnly: '管理员和有效付费会员可缓存预告片到 R2。',
    noSource: '缓存失败：暂时没有找到可用的预告片来源。',
    failed: '预告片缓存失败，请稍后重试；仍可尝试播放原来源。',
    outcomeUnknown: '缓存结果暂时无法确认，请先刷新影片查看，避免重复提交缓存。',
    alreadyActive: '这部影片正在处理预告片，请稍后刷新影片查看。',
    unknown: '请求可能已提交，点击“确认预告片状态”查询原请求，请勿重复提交。',
    disconnected: '暂时无法读取任务状态，点击“确认预告片状态”继续查询。',
    checkVideo: '刷新影片信息',
    manual: '管理员手动补充预告片',
    source: '补源方式',
    file: '上传本地文件',
    url: '预告片 URL',
    fileHint: '支持 MP4 / MPEG-TS，最大 200 MiB。服务端会核验视频内容。',
    urlHint: '使用受支持来源的视频直链，服务端会验证来源并缓存。',
    invalidFile: '请选择非空的 MP4 / MPEG-TS 文件，大小不能超过 200 MiB。',
    submit: '提交预告片',
    uploadProgress: '正在验证并保存预告片…',
    uploadFailed: '预告片保存失败，请检查来源或文件后重试。',
  },
  'zh-TW': {
    cache: '快取至 R2',
    finding: '正在尋找預告片來源…',
    refreshSources: '重新尋找來源',
    sourceError: '預告片來源查詢失敗，請重試。',
    playFailed: '所有预告片來源播放失敗，請更新來源後重試。',
    refresh: '重新擷取預告片',
    fetching: '正在快取至 R2…',
    confirm: '確認預告片狀態',
    progress: '正在將預告片快取至 R2，可能需要幾分鐘；仍可播放原來源。',
    paidOnly: '管理員及有效付費會員可將預告片快取至 R2。',
    noSource: '快取失敗：暫時找不到可用的預告片來源。',
    failed: '預告片快取失敗，請稍後重試；仍可嘗試播放原來源。',
    outcomeUnknown: '暫時無法確認快取結果，請先更新影片資訊，避免重複提交快取。',
    alreadyActive: '這部影片的預告片正在處理，請稍後更新影片資訊。',
    unknown: '請求可能已提交，請點選「確認預告片狀態」查詢原請求，勿重複提交。',
    disconnected: '暫時無法讀取任務狀態，請點選「確認預告片狀態」繼續查詢。',
    checkVideo: '更新影片資訊',
    manual: '管理員手動補充預告片',
    source: '來源方式',
    file: '上傳本機檔案',
    url: '預告片 URL',
    fileHint: '支援 MP4 / MPEG-TS，最大 200 MiB。伺服器會驗證影片內容。',
    urlHint: '請使用支援來源的影片直接連結，伺服器會驗證來源並快取。',
    invalidFile: '請選擇非空的 MP4 / MPEG-TS 檔案，大小不得超過 200 MiB。',
    submit: '提交預告片',
    uploadProgress: '正在驗證並儲存預告片…',
    uploadFailed: '預告片儲存失敗，請檢查來源或檔案後重試。',
  },
  en: {
    cache: 'Cache to R2',
    finding: 'Finding trailer sources…',
    refreshSources: 'Find sources again',
    sourceError: 'Could not load trailer sources. Please retry.',
    playFailed: 'All trailer sources failed to play. Refresh sources and retry.',
    refresh: 'Fetch trailer',
    fetching: 'Caching to R2…',
    confirm: 'Check trailer status',
    progress: 'Caching the trailer to R2. This may take a few minutes; direct playback remains available.',
    paidOnly: 'R2 caching is available to admins and active paid members.',
    noSource: 'Cache failed: no available trailer source was found.',
    failed: 'Trailer caching failed. You can still try direct playback.',
    outcomeUnknown:
      'The cache result is uncertain. Refresh the video before submitting another cache request.',
    alreadyActive: 'A trailer task is already in progress. Refresh the video shortly.',
    unknown: 'The request may have been submitted. Check its status before submitting again.',
    disconnected: 'Task status is unavailable. Check the trailer status to reconnect.',
    checkVideo: 'Refresh video',
    manual: 'Admin: add a trailer manually',
    source: 'Source',
    file: 'Upload local file',
    url: 'Trailer URL',
    fileHint: 'MP4 / MPEG-TS, up to 200 MiB. The server validates video content.',
    urlHint: 'Use a direct video URL from a supported source. The server validates and caches it.',
    invalidFile: 'Choose a non-empty MP4 / MPEG-TS file no larger than 200 MiB.',
    submit: 'Submit trailer',
    uploadProgress: 'Validating and saving trailer…',
    uploadFailed: 'Could not save the trailer. Check the source or file and retry.',
  },
  ja: {
    cache: 'R2 に保存',
    finding: '予告編の配信元を検索中…',
    refreshSources: '配信元を再検索',
    sourceError: '予告編の配信元を取得できません。再試行してください。',
    playFailed: 'すべての配信元で再生に失敗しました。配信元を更新して再試行してください。',
    refresh: '予告編を取得',
    fetching: 'R2 に保存中…',
    confirm: '予告編の状態を確認',
    progress: '予告編を R2 に保存しています。元の配信元から引き続き再生できます。',
    paidOnly: '管理者と有効な有料会員が予告編を R2 に保存できます。',
    noSource: '保存失敗：利用可能な予告編が見つかりませんでした。',
    failed: '予告編の保存に失敗しました。元の配信元から再生できます。',
    outcomeUnknown: '保存結果を確認できません。再度保存する前に作品情報を更新してください。',
    alreadyActive: 'この作品の予告編を処理中です。しばらくしてから作品情報を更新してください。',
    unknown: 'リクエストが送信された可能性があります。再送信する前に状態を確認してください。',
    disconnected: 'タスクの状態を取得できません。状態を確認して再接続してください。',
    checkVideo: '作品情報を更新',
    manual: '管理者：予告編を手動で追加',
    source: '追加方法',
    file: 'ローカルファイルをアップロード',
    url: '予告編 URL',
    fileHint: 'MP4 / MPEG-TS、最大 200 MiB。サーバーで動画内容を検証します。',
    urlHint: '対応する配信元の動画への直接 URL を指定してください。サーバーで検証して保存します。',
    invalidFile: '空でない 200 MiB 以下の MP4 / MPEG-TS ファイルを選択してください。',
    submit: '予告編を送信',
    uploadProgress: '予告編を検証・保存中…',
    uploadFailed: '予告編を保存できませんでした。URL またはファイルを確認して再試行してください。',
  },
  ko: {
    cache: 'R2에 저장',
    finding: '예고편 출처 검색 중…',
    refreshSources: '출처 다시 검색',
    sourceError: '예고편 출처를 조회하지 못했습니다. 다시 시도해 주세요.',
    playFailed: '모든 예고편 출처에서 재생에 실패했습니다. 출처를 새로고침해 주세요.',
    refresh: '예고편 가져오기',
    fetching: 'R2에 저장 중…',
    confirm: '예고편 상태 확인',
    progress: '예고편을 R2에 저장하고 있습니다. 원래 출처에서 계속 재생할 수 있습니다.',
    paidOnly: '관리자와 유효한 유료 회원이 예고편을 R2에 저장할 수 있습니다.',
    noSource: '저장 실패: 사용 가능한 예고편을 찾지 못했습니다.',
    failed: '예고편을 저장하지 못했습니다. 원래 출처에서 재생할 수 있습니다.',
    outcomeUnknown:
      '저장 결과를 확인할 수 없습니다. 다시 저장을 요청하기 전에 영상 정보를 새로고침해 주세요.',
    alreadyActive: '이 영상의 예고편을 처리 중입니다. 잠시 후 영상 정보를 새로고침해 주세요.',
    unknown: '요청이 제출되었을 수 있습니다. 다시 제출하기 전에 상태를 확인해 주세요.',
    disconnected: '작업 상태를 읽을 수 없습니다. 예고편 상태를 확인하여 다시 연결해 주세요.',
    checkVideo: '영상 정보 새로고침',
    manual: '관리자: 예고편 직접 추가',
    source: '추가 방법',
    file: '로컬 파일 업로드',
    url: '예고편 URL',
    fileHint: 'MP4 / MPEG-TS, 최대 200 MiB. 서버에서 영상 내용을 확인합니다.',
    urlHint: '지원되는 출처의 영상 직접 링크를 입력하세요. 서버에서 확인하고 저장합니다.',
    invalidFile: '비어 있지 않은 200 MiB 이하의 MP4 / MPEG-TS 파일을 선택하세요.',
    submit: '예고편 제출',
    uploadProgress: '예고편 확인 및 저장 중…',
    uploadFailed: '예고편을 저장하지 못했습니다. 출처나 파일을 확인하고 다시 시도하세요.',
  },
} as const
